import Accordion from './components/Accordion';
import AccordionItem from './components/AccordionItem';

export { Accordion, AccordionItem };
export default Accordion;



// WEBPACK FOOTER //
// ./src/lib/index.js